import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/components/shared/myLink/MyLink.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/safiruni/front/public/images/404.svg");
